import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "login",
    meta: {
      title: "阳光采购服务平台-登录",
    },
    component: () => import(/* webpackChunkName: "login" */ "../views/login"),
  },
  {
    path: "/register",
    component: () => import("../layouts/BasicLayout"),
    children: [
      {
        path: "/register",
        name: "register",
        meta: {
          title: "阳光采购服务平台-注册",
        },
        component: () =>
          import(
            /* webpackChunkName: "register" */ "../views/register/register"
          ),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
